import { object, string } from 'yup'

import type { CreateObjectAddressStepResponse } from 'shared/api/kyrgyzstan/create-object'
import { createYupFormResolver } from 'shared/lib/form'

export interface CreateObjectAddressFormValues {
  regionId: string
  cityId: string
  street: string
  houseNumber: string
}

export const createObjectAddressFormDefaultValues: CreateObjectAddressFormValues =
  {
    regionId: '',
    cityId: '',
    street: '',
    houseNumber: '',
  }

const requiredFieldMessage = ''

const createObjectAddressFormSchema = object({
  regionId: string().trim().required(requiredFieldMessage),
  cityId: string().trim().required(requiredFieldMessage),
  street: string().trim().required(requiredFieldMessage),
  houseNumber: string().trim().required(requiredFieldMessage),
})

export const createObjectAddressFormResolver =
  createYupFormResolver<CreateObjectAddressFormValues>(
    createObjectAddressFormSchema,
  )

export const mapCreateObjectAddressResponseToFormValues = (
  address: CreateObjectAddressStepResponse,
): CreateObjectAddressFormValues => ({
  regionId: address.region_id ?? '',
  cityId: address.city_id === null ? '' : String(address.city_id),
  street: address.street ?? '',
  houseNumber: address.house_number ?? '',
})
